import React, { useContext, useRef, useLayoutEffect, useEffect, useState } from "react";
import { UserContext, isLoggedIn, handleLogout } from "@parallelpublicworks/entitysync";
import cx from "classnames";
import useMedia from "use-media";
import { Login16, Logout16 } from "@carbon/icons-react";
import NavContext from "gatsby-theme-carbon/src/util/context/NavContext";
import { nav, open, divider, link, linkDisabled } from "./Switcher.module.scss";
import {Button} from 'carbon-components-react';
import { navigate } from "gatsby";

const Switcher = () => {
  const userContext = useContext(UserContext);
  const lgBreakpoint = useMedia("min-width: 1056px");
  const { switcherIsOpen, toggleNavState } = useContext(NavContext);
  const listRef = useRef(null);
  const [height, setHeight] = useState(0);

  const logged_in = typeof userContext[0] !== `undefined` && isLoggedIn(userContext);

  const logout = (e) => {
    return handleLogout(userContext, e);
  };

  const closeDialog = (e) => {
    navigate("/edit-profile")
    return toggleNavState("switcherIsOpen", "close");
  };

  useEffect(() => {
    const collapseOpenNavs = function (e) {
      if (e.which === 27) {
        toggleNavState("switcherIsOpen", "close");
      }
    };

    document.addEventListener("keyup", collapseOpenNavs);

    return function cleanup() {
      document.removeEventListener("keyup", collapseOpenNavs);
    };
  }, [toggleNavState]);

  // calculate and update height
  useLayoutEffect(() => {
    if (switcherIsOpen) {
      setHeight(listRef.current.offsetHeight + 40);
    } else {
      setHeight(0);
    }
  }, [listRef, switcherIsOpen]);

  const maxHeight = !lgBreakpoint && switcherIsOpen ? "100%" : `${height}px`;

  return (
    <>
    <nav
      className={cx(nav, { [open]: switcherIsOpen })}
      tabIndex="-1"
      style={{ maxHeight , backgroundColor : "#565656"}}
    >
      <ul ref={listRef}>
        <>
          <SwitcherDivider>User Account</SwitcherDivider>
          <Button
          kind="secondary" 
          onClick={(e) => closeDialog()}>
            Edit Profile
          </Button>
          <SwitcherLink
            href={logged_in ? "#" : "/"}
            isLogin={!logged_in}
            isLogout={logged_in}
            toggleNavState={toggleNavState}
            onClick={(e) => {
              if (logged_in) {
                logout();
              }
            }}
          >
            {logged_in ? "Logout" : "Login"}
          </SwitcherLink>
        </>
      </ul>
    </nav>
    </>
  );
};

export const SwitcherDivider = (props) => (
  <li className={divider}>
    <span {...props} />
  </li>
);

export const SwitcherLink = ({
  disabled,
  children,
  isLogin,
  isLogout,
  href: hrefProp,
  toggleNavState,
  onClick,
  ...rest
}) => {
  const href = disabled || !hrefProp ? undefined : hrefProp;
  const className = disabled ? linkDisabled : link;
  const { switcherIsOpen } = useContext(NavContext);
  const openTabIndex = disabled ? "-1" : 0;

  return (
    <li>
      <a
        aria-disabled={disabled}
        role="button"
        tabIndex={switcherIsOpen ? openTabIndex : "-1"}
        className={className}
        href={href}
        {...rest}
        onClick={() => {
          toggleNavState("switcherIsOpen", "close");
          if (onClick) onClick();
        }}
      >
        {children}
        {isLogin && <Login16 />}
        {isLogout && <Logout16 />}
      </a>
    </li>
  );
};

export default Switcher;
